import { IBookmarkState, IBookmarkObjState } from './types';

interface ISetBookmarkName {
  type: 'SET_BOOKMARK_NAME';
  bookmarkName: string;
  bookmarkLink: string;
  bookmarkModule: string;
}

interface IActionGetBookmarksSuccess {
  type: 'GET_BOOKMARKS_SUCCESS';
  bookmarks: IBookmarkObjState[];
}

interface IActionSetUserSearchInput {
  type: 'SET_USER_SEARCH_INPUT';
  searchInputValue: string;
}

interface IActionRenameBookmarkSuccess {
  type: 'RENAME_BOOKMARK_SUCCESS';
}

interface IActionAddBookmarkSuccess {
  type: 'ADD_BOOKMARK_SUCCESS';
}

export const initialState: IBookmarkState = {
  bookmarkLink: '',
  bookmarkName: '',
  bookmarkModule: '',
  bookmarks: [],
  searchInputValue: '',
  renameBookmarkSuccess: false,
  addBookmarkSuccess: false,
};

type TBookmarkAction =
  | ISetBookmarkName
  | IActionGetBookmarksSuccess
  | IActionSetUserSearchInput
  | IActionRenameBookmarkSuccess
  | IActionAddBookmarkSuccess;

export default (state = initialState, action: TBookmarkAction) => {
  switch (action.type) {
    case 'SET_BOOKMARK_NAME': {
      return {
        ...state,
        bookmarkName: action.bookmarkName,
        bookmarkLink: action.bookmarkLink,
        bookmarkModule: action.bookmarkModule,
      };
    }
    case 'GET_BOOKMARKS_SUCCESS': {
      return {
        ...state,
        bookmarks: action.bookmarks,
        renameBookmarkSuccess: false,
        addBookmarkSuccess: false,
      };
    }
    case 'SET_USER_SEARCH_INPUT': {
      return {
        ...state,
        searchInputValue: action.searchInputValue,
      };
    }
    case 'RENAME_BOOKMARK_SUCCESS': {
      return {
        ...state,
        renameBookmarkSuccess: true,
      };
    }
    case 'ADD_BOOKMARK_SUCCESS': {
      return {
        ...state,
        addBookmarkSuccess: true,
      };
    }
    default: {
      return state;
    }
  }
};
